import { ReactNode } from "react";
import { useAppState } from "../AppProvider/AppProvider";

export const usePermission = (permission: string) => {
  const [ctx] = useAppState() ?? [];
  return Boolean(ctx?.permissions.includes(permission));
};

export const Can = ({
  permission,
  children,
  fallback = null,
}: {
  permission: string;
  children: ReactNode;
  fallback?: ReactNode;
}) => (usePermission(permission) ? <>{children}</> : <>{fallback}</>);
